// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1_Ui_","rootSuccess":"CompleteLink_rootSuccess__37b3K","rootFailure":"CompleteLink_rootFailure__1mXVg","isDisabled":"CompleteLink_isDisabled__yQIMq"};